(() => {
  const MAP = {
    L: "50–65 KG",
    XL: "65–75 KG",
    "2XL": "75–90 KG",
    "3XL": "90–110 KG",
    "4XL": "110–130 KG",
    "5XL": "130–145 KG"
  };

  const OPTION_NAME_MATCH = ["size", "sizes", "المقاس"];

  function isSizeOption(name) {
    if (!name) return false;
    return OPTION_NAME_MATCH.includes(name.trim().toLowerCase());
  }

  function decorateVariantPicker(root = document) {
    // A) Buttons / pills (fieldset + labels)
    root.querySelectorAll("fieldset").forEach((fs) => {
      const legend = fs.querySelector("legend");
      const optName = legend?.textContent?.trim() || "";
      if (!isSizeOption(optName)) return;

      fs.querySelectorAll("label").forEach((label) => {
        const forId = label.getAttribute("for");
        let val = "";

        if (forId) {
          const input =
            root.getElementById(forId) ||
            fs.querySelector(`#${CSS.escape(forId)}`);
          val = input?.value || input?.getAttribute("data-value") || "";
        }

        val = (val || "").trim();
        if (!MAP[val]) return;

        // prevent duplicates
        if (label.querySelector(".size-kg")) return;

        const span = document.createElement("span");
        span.className = "size-kg";
        span.textContent = ` (${MAP[val]})`;
        label.appendChild(span);
      });
    });

    // B) Dropdown selects
    root.querySelectorAll("select").forEach((sel) => {
      const label = root.querySelector(`label[for="${sel.id}"]`);
      const optName = label?.textContent?.trim() || "";
      if (optName && !isSizeOption(optName)) return;

      sel.querySelectorAll("option").forEach((op) => {
        const val = (op.value || "").trim();
        if (!MAP[val]) return;
        if (op.textContent.includes(MAP[val])) return;
        op.textContent = `${val} (${MAP[val]})`;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => decorateVariantPicker(document));
  document.addEventListener("shopify:section:load", (e) => decorateVariantPicker(e.target));
})();
